/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enums_Leerjaar_Een2Inputs */

const nl_enums_leerjaar_een2 = /** @type {(inputs: Enums_Leerjaar_Een2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leerjaar 1`)
};

/**

* @param {Enums_Leerjaar_Een2Inputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const enums_leerjaar_een2 = /** @type {((inputs?: Enums_Leerjaar_Een2Inputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enums_Leerjaar_Een2Inputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_enums_leerjaar_een2(inputs)
});
export { enums_leerjaar_een2 as "enums.Leerjaar.Een" }